export const ShopContext = {
  init() {
    // TODO: read this dynamically, generate from kubecfg; idea: generate js or json and import it
    this.tenantCode = 'GM';
    this.shopCode = 'GRM';
  },
  shopCode: '',
  tenantCode: '',
};
